import React from 'react'
import { useContext } from 'react';
import { useEffect } from 'react';
import { Link } from 'react-router-dom'
import { GlobalState } from '../../../GlobalState';
import Loading from '../../../util/Loading';
import { TabTitle } from '../../../util/titleChanger'
import ReactPaginate from 'react-paginate';

export default function DamageDashboard() {
    TabTitle("Damage Dashboard");
    const state = useContext(GlobalState)
    const signInUser = JSON.parse(localStorage.getItem('user_data'));

    const [damages] = state.damageAPI.damages;

    //Import State
    const [rowPerPage] = state.damageAPI.rowPerPage;
    const [pageNumber, setPageNumber] = state.damageAPI.pageNumber;
    const [totalPages] = state.damageAPI.totalPages;
    const [setSearch] = state.damageAPI.search;

    const pageNumberHandler = (data) => {
        let newPageNumber = data.selected + 1;
        setPageNumber(newPageNumber)
    }

    const searchHandler = (e) => {
        e.preventDefault();
        setPageNumber(1);
        setSearch(e.target.value ? e.target.value : "");
    }

    const dateConverter = (date) => {
        let convertedDate = new Date(date).toISOString().slice(0, 10);
        return convertedDate
    }

    useEffect(() => { }, [rowPerPage, pageNumber, damages])

    return (
        <div className='form-container'>
            <div className="table">
                <div className="table_header">
                    <p>Damage Product Details</p>
                    <div>
                        <input
                            type="text"
                            name="search"
                            id="search"
                            placeholder='Search damage product here...'
                            onChange={(e) => searchHandler(e)}
                        />
                        <Link to="/damage-form"><button className="add_new">+ Add New</button></Link>
                    </div>
                </div>

                {
                    damages.count === 0 ? <div className="loading-page-container"><Loading /></div>
                        : <div className="table_section">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Damage Code</th>
                                        <th>Customer Name</th>
                                        <th>Product Name</th>
                                        <th>Qty</th>
                                        <th>Created At</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        damages.count > 0 ? damages.data.map(damage => (
                                            <tr key={damage.id}>
                                                <td>{damage.damage_code}</td>
                                                <td>{damage.customer.first_name + " " + damage.customer.last_name}</td>
                                                <td>{damage.product.name}</td>
                                                <td>{damage.quantity}</td>
                                                <td>{dateConverter(damage.created_at)}</td>
                                                <td>
                                                    <Link to={`/damage-form/${damage.id}`}><button><i className="uil uil-edit"></i></button></Link>
                                                </td>
                                            </tr>
                                        ))
                                            : <tr>
                                                <td colSpan={6}>Can not found any purchase details.</td>
                                            </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                }

                <ReactPaginate
                    breakLabel="..."
                    nextLabel="next >"
                    onPageChange={pageNumberHandler}
                    marginPagesDisplayed={2}
                    pageCount={totalPages}
                    previousLabel="< previous"
                    renderOnZeroPageCount={null}
                    containerClassName='pagination'
                    pageLinkClassName='page-num'
                    previousLinkClassName='page-num'
                    nextLinkClassName='page-num'
                    activeLinkClassName='active-num'
                />
            </div>
        </div>
    )
}
